import { ErrorHandler, Injectable } from "@angular/core";

const RELOAD_GUARD_KEY = "chunk-reload-attempted-at";
const RELOAD_GUARD_WINDOW_MS = 10_000;

@Injectable()
export class ChunkErrorHandler extends ErrorHandler {
  handleError(error: any): void {
    if (this.isChunkLoadError(error) && this.shouldReload()) {
      sessionStorage.setItem(RELOAD_GUARD_KEY, Date.now().toString());
      window.location.reload();
      return;
    }
    super.handleError(error);
  }

  private isChunkLoadError(error: any): boolean {
    const message: string =
      (error && (error.message || error.rejection?.message)) || "";
    const name: string =
      (error && (error.name || error.rejection?.name)) || "";
    return name === "ChunkLoadError" || /Loading chunk \S+ failed/i.test(message);
  }

  private shouldReload(): boolean {
    try {
      const last = sessionStorage.getItem(RELOAD_GUARD_KEY);
      if (!last) return true;
      return Date.now() - parseInt(last, 10) > RELOAD_GUARD_WINDOW_MS;
    } catch {
      return true;
    }
  }
}
